import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Cookies from 'js-cookie'
import Element from 'element-ui'
import {i18n} from './i18n/index.js'; 

Vue.config.productionTip = false
// import './utils/error-log' // error log

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
